import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-main">
          <div className="footer-brand">
            <span className="footer-eyebrow">TIMBAKTU ACADEMY</span>
            <h2>Build skills. Create boldly.</h2>
            <p>Practical digital courses that help curious minds turn ideas into meaningful work.</p>
          </div>

          <div className="footer-contact">
            <span className="footer-label">Reach us</span>
            <a href="tel:+254713278747">
              <i className="fa fa-phone-alt" aria-hidden="true"></i>
              <span>+254 713 27 87 47</span>
            </a>
            <a href="mailto:info@timbaktu.co.ke">
              <i className="fas fa-envelope" aria-hidden="true"></i>
              <span>info@timbaktu.co.ke</span>
            </a>
          </div>

          <div className="footer-social">
            <span className="footer-label">Follow along</span>
            <div className="social-links">
              <a href="https://www.facebook.com/timbaktu.academy" aria-label="Facebook"><i className="fab fa-facebook" aria-hidden="true"></i><span className="visually-hidden">Facebook</span></a>
              <a href="#twitter" aria-label="Twitter"><i className="fab fa-twitter" aria-hidden="true"></i><span className="visually-hidden">Twitter</span></a>
              <a href="#linkedin" aria-label="LinkedIn"><i className="fab fa-linkedin" aria-hidden="true"></i><span className="visually-hidden">LinkedIn</span></a>
              <a href="https://www.instagram.com/timbaktu_academy/" aria-label="Instagram"><i className="fab fa-instagram" aria-hidden="true"></i><span className="visually-hidden">Instagram</span></a>
            </div>
          </div>
        </div>

        <div className="footer-copyright">
          <p>&copy;{new Date().getFullYear()} Timbaktu Academy. All rights reserved.</p>
          <span>Learn something useful today.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
